export const SAMPLES_FILTERS_STORAGE_KEY = "samplesFilters";
